import React, { useState, useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import api from "../Api";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from '../components/PopUP';

const ManufacturerDetails = () => {
  const { id } = useParams();
  const [manufacturerDetails, setManufacturerDetails] = useState({});
  const [popupMessage, setPopupMessage] = useState("Loading manufacturer details...");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchManufacturerDetails = async () => {
      setLoading(true);
      try {
        const response = await api.get(`/airplane-service/manufacturer/${id}`);
        console.log("Manufacturer Details:", response.data);
        setManufacturerDetails(response.data);
        setPopupMessage("Manufacturer details loaded successfully");
      } catch (error) {
        console.error("Error fetching manufacturer details:", error);
        setPopupMessage("Error loading manufacturer details");
      }
      setLoading(false);
    };

    fetchManufacturerDetails();
  }, [id]);

  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <nav className="breadcrumb_nav">
                          <ul className="breadcrumb mb-0">
                            <li className="breadcrumb-item">
                              <a href="dashboard.html">Dashboard</a>
                            </li>
                            <li className="breadcrumb-item">
                              <Link to="/manufacturer">Manufacturer Management</Link>
                            </li>
                            <li className="breadcrumb-item text-capitalize">Manufacturer Detail</li>
                          </ul>
                        </nav>
                        <h1>Manufacturer Detail</h1>
                      </div>
                    </div>
                  </div>
                  <div className="outline_tab_card mt-4">
                    <nav>
                      <div className="nav nav-tabs" id="nav-tab" role="tablist">
                        <button
                          className="nav-link active"
                          id="nav-1-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-1"
                          type="button"
                          role="tab"
                          aria-controls="nav-1"
                          aria-selected="true"
                        >
                          General Details
                        </button>
                        <button
                          className="nav-link"
                          id="nav-2-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-2"
                          type="button"
                          role="tab"
                          aria-controls="nav-2"
                          aria-selected="false"
                        >
                          Company Description
                        </button>
                        <button
                          className="nav-link"
                          id="nav-3-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-3"
                          type="button"
                          role="tab"
                          aria-controls="nav-3"
                          aria-selected="false"
                        >
                          Company History
                        </button>
                        <button
                          className="nav-link"
                          id="nav-4-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-4"
                          type="button"
                          role="tab"
                          aria-controls="nav-4"
                          aria-selected="false"
                        >
                          Interesting Facts
                        </button>
                        <button
                          className="nav-link"
                          id="nav-5-tab"
                          data-bs-toggle="tab"
                          data-bs-target="#nav-5"
                          type="button"
                          role="tab"
                          aria-controls="nav-5"
                          aria-selected="false"
                        >
                          Products
                        </button>
                      </div>
                    </nav>
                  </div>
                  {loading ? <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "300px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                  </div> : (
                    <div className="tab_blk">
                      <div className="tab-content" id="nav-tabContent">
                        <div
                          className="tab-pane fade show active"
                          id="nav-1"
                          role="tabpanel"
                          aria-labelledby="nav-1-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>General Information</h2>
                            </div>
                            <div className="common_content_blk">
                              <div className="box_card manufacturer_profile_card common-card">
                                <div className="box_detail_blk">
                                  <div className="box_info_list">
                                    <div className="box_info_context">
                                      <p className="box_info_title">Company Name</p>
                                      <p className="box_info_data text-capitalize">{manufacturerDetails.data?.general.company_name}</p>
                                    </div>
                                    <div className="box_info_context">
                                      <p className="box_info_title">Headquarter</p>
                                      <p className="box_info_data">{manufacturerDetails.data?.general.headquarter}</p>
                                    </div>
                                    <div className="box_info_context">
                                      <p className="box_info_title">Founding Date</p>
                                      <p className="box_info_data">{manufacturerDetails.data?.general.founding_date}</p>
                                    </div>
                                    <div className="box_info_context">
                                      <p className="box_info_title">Logo</p>
                                      <p className="box_info_data">
                                        <img src={manufacturerDetails.data?.general.logo} alt='logo' style={{ width: "12%" }} className='rounded' />
                                      </p>
                                    </div>
                                    <div className="box_info_context">
                                      <p className="box_info_title">Cover Photo</p>
                                      <p className="box_info_data">
                                        <img src={manufacturerDetails.data?.general.cover_photo.url} alt='cover' style={{ width: "50%" }} className='rounded' />
                                      </p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="nav-2"
                          role="tabpanel"
                          aria-labelledby="nav-2-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Company Description</h2>
                            </div>
                            <div className="common_content_blk">
                              <div className="box_card manufacturer_profile_card common-card">
                                <div className="box_detail_blk">
                                  <div className="box_info_list">
                                    <div className="box_info_context_1">
                                      <p className="box_info_title fw-bold">Company Description</p>
                                      <p className="box_info_data mt-2">{manufacturerDetails.data?.company?.company_description}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="nav-3"
                          role="tabpanel"
                          aria-labelledby="nav-3-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Company History</h2>
                            </div>
                            <div className="common_content_blk">
                              <div className="box_card manufacturer_profile_card common-card">
                                <div className="box_detail_blk">
                                  <div className="box_info_list">
                                    <div className="box_info_context_1">
                                      <p className="box_info_title fw-bold">Company History</p>
                                      <p className="box_info_data mt-2">{manufacturerDetails.data?.company?.company_history}</p>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="nav-4"
                          role="tabpanel"
                          aria-labelledby="nav-4-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Interesting Facts</h2>
                            </div>
                            <div className="common_content_blk">
                              <div className="box_card manufacturer_profile_card common-card">
                                <div className="box_detail_blk">
                                  <div className="box_info_list">
                                    <div className="box_info_context_1">
                                      <p className="box_info_title fw-bold">Interesting Facts</p>
                                      <div className="box_info_data mt-2">
                                        {manufacturerDetails.data?.interesting_facts?.length ? (
                                          manufacturerDetails.data.interesting_facts.map((fact, idx) => (
                                            <p key={idx}><span>{idx + 1}. </span>{fact}</p>
                                          ))
                                        ) : (
                                          <p>No interesting facts available.</p>
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="tab-pane fade"
                          id="nav-5"
                          role="tabpanel"
                          aria-labelledby="nav-5-tab"
                          tabIndex="0"
                        >
                          <div className="common-outer-card">
                            <div className="common_sub_heading_wrapper">
                              <h2>Product Details</h2>
                            </div>
                            {manufacturerDetails.data?.product && manufacturerDetails.data.product.length > 0 ? (
                              manufacturerDetails.data.product.map((product, index) => (
                                <div className="common_content_blk" key={index}>
                                  <div className="box_card manufacturer_profile_card common-card">
                                    <div className="box_detail_blk">
                                      <div className="box_info_list">
                                        <div className="box_info_context">
                                          <p className="box_info_data text-capitalize">{product.series}</p>
                                        </div>
                                        <div className="box_info_context">
                                          <div className="box_info_data">
                                            {product.data && product.data.length > 0 ? (
                                              <ul>
                                                {product.data.map((model, idx) => (
                                                  <li key={idx}>{model}</li>
                                                ))}
                                              </ul>
                                            ) : (
                                              <span>No models listed</span>
                                            )}
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              ))
                            ) : (
                              <div className="common_content_blk">
                                <p>No product information available.</p>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default ManufacturerDetails;
